/* eslint-disable consistent-return */
import { initialiseGame } from '../actions/initGame.actions'
import { initialiseInventory } from '../actions/game/inventory.actions'
import { initialiseRoster } from '../actions/game/roster.actions'
import { initialiseResources } from '../actions/game/resources.actions'
import { goToHome } from '../actions/routing/route.actions'
import MANIFEST from '../../constants/MANIFEST'

const initGameMiddleware = ({ dispatch, getState }) => next => (action) => {
    const { initGameAction } = action.meta || {}
    const { gameInitialised: { status, version } } = getState()

    if (initGameAction) {
        return next(action)
    }

    if (status && (version === MANIFEST.version)) {
        return next(action)
    }

    if (status && (version < MANIFEST.version)) {
        // console.log('old version detected')
        // ToDo: implement code to check for breaking changes and update player data before
        //  increasing the current game version number in state
        return next(action)
    }

    dispatch(initialiseGame())
    dispatch(initialiseInventory())
    dispatch(initialiseRoster())
    dispatch(initialiseResources())
    dispatch(goToHome())
}

export default initGameMiddleware
